import { graphql } from "gql";

const MESSAGE_THREAD_FILES_DRAWER_QUERY = graphql(`
  query MessageThreadFilesDrawer($id: ID!) {
    messageThread(id: $id) {
      ...MessageThreadFilesDrawer
    }
  }
`);

export default MESSAGE_THREAD_FILES_DRAWER_QUERY;
